import { ISubscriptionPlan } from '../interface/ISubscriptionPlan'

import { SET_SUBSCRIPTION_PLAN } from './actionTypes'

export const setSubscriptionPlan = (plan: ISubscriptionPlan) => ({
  type: SET_SUBSCRIPTION_PLAN,
  payload: {
    ...plan,
  },
})
